<template>
    <div class="page-wrapper">
        <TopBarGray
            :title="pageTitle"
            customClass="bg-history"
            @clickBack="clickBack()"/>
        <MonthYearDDL
            customClass="history-date-input"
            :lbl="lbl"
            :localeCode="localeCode"
            :inputLbl="lbl.history.month_year_form"
            v-model="filterDate"
            @onDateChange="onDateChange($event)"
            v-if="type == 'earn'"/>
        <div id="history_content" class="page-content"
            :class="{'page-content-narrow' : type == 'burn'}"
            v-if="isLoaded">
            <EarnList
                :lbl="lbl"
                :initListConfig="earnListConfig"
                :busEvent="busEvent"
                @toggleLoading="toggleLoading($event)"
                v-if="type == 'earn'" />
            <BurnList
                :lbl="lbl"
                :isLoading="isLoading"
                :listConfig="purchaseListConfig"
                :filterConfig="purchaseFilterListConfig"
                :busEvent="busHistory"
                :modalController="modalController"
                @toggleLoading="toggleLoading($event)"
                v-if="type == 'burn'" />
        </div>

        <ModalMaster :controller="modalController" />
    </div>
</template>
<script>
import Vue from "vue";
//helper
import CacheHelper from "@/helper/CacheHelper.js";
//mixin
import AccountMixin from '@/mixin/AccountMixin.js';
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
import ScrollPageMixin from '@/mixin/ScrollPageMixin.js';
//component
import EarnList from '../component/EarnList.vue';
import BurnList from '../component/BurnList.vue';
import MonthYearDDL from '../component/MonthYearDDL.vue';
import TopBarGray from '@/components/Layout/TopBarPage/TopBarGray.vue';
//core
import ConfigManager from "@/config/ConfigManager.js";
import {
    PurchaseListConfigBuilder,
    PurchaseFilterConfigBuilder,
    PointListConfigBuilder
} from "@/core/History/model/HistoryConfigModel.js";

export default {
    name: 'History',
    mixins: [AccountMixin, ErrorApiMixin, LocaleMixin, ModalMixin, ScrollPageMixin],
    components: {
        BurnList,
        EarnList,
        MonthYearDDL,
        TopBarGray
    },
    data: function () {
        return {
            busEvent: new Vue(),

            filterDate: new Date(),
            filterMonthYear: '',
            isLoaded: false,
            type: 'burn', //burn, earn

            purchaseListConfig: {},
            purchaseFilterListConfig: {},
            earnListConfig: {},
            isLoading: false,
            busHistory: new Vue(),

            pageTitle: '',
        };
    },
    created: function () {
        this.type = this.$route.params.type ? this.$route.params.type : 'burn';

        if(this.type == 'burn'){
            this.initialPurchase();
            this.pageTitle = this.lbl.history.page_title_burn;
            this.initialHistoryModal();
        }else{
            this.initialEarnConfig();
            this.pageTitle = this.lbl.history.page_title_earn;
        }
    },
    methods: {
        //initail config
        initialPurchase: function () {
            var listConfig = new PurchaseListConfigBuilder()
                .setConfigList(ConfigManager.getHistoryConfig().purchase)
                .create();
            this.purchaseListConfig = listConfig;

            //initial filter config for api.
            var filterListConfig = new PurchaseFilterConfigBuilder()
                .create();
            this.purchaseFilterListConfig = filterListConfig;
        },
        initialEarnConfig: function () {
            var listConfig = new PointListConfigBuilder()
                .setDate(this.filterMonthYear) 
                .setType("all")
                .create();
            this.earnListConfig = listConfig;
        },
        //event
        clickBack: function () {
            var cache = new CacheHelper('session');
            
            if(cache.getCache('FromPage')){
                var backPath = cache.getCache('FromPage');
                this.$router.push(backPath);

                cache.removeCache('FromPage')
                
            }else{
                this.$router.back();
            }

            console.log('data');
        },
        onDateChange: function (data) {
            if (data.date
                && this.filterMonthYear == data.date) return;

            this.filterMonthYear = data.date;

            this.initialEarnConfig();
            this.busEvent.$emit("reInitList", {listConfig: this.earnListConfig});
        },
        //mixin
        accountInitiated: function () {
            this.isLoaded = true;
        },
        //utility
        showLoading: function() {
            setTimeout(() => {
                this.loadingModal.show();
            },0)
        },
        hideLoading: function() {
            setTimeout(() => {
                this.loadingModal.hide();
            },300)
        },
        toggleLoading: function (isLoading) {
            this.isLoading = isLoading;
            if(this.isLoading){
                this.showLoading();
            }else{
                this.hideLoading();
            }
        },
    }
}
</script>
<style lang="scss" scoped>
@import '@/style/base/base.scss';
@import './History.scss';
</style>
